import styled from "styled-components";

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 25px;
  border-radius: 5px;

  @media screen and (max-width: 450px) {
    width: 300px;
  }
`;

export const Close = styled.span`
  display: flex;
  position: absolute;
  right: 8px;
  top: 8px;
  //margin-top: 0px;
  cursor: pointer;
  z-index: 9999;
`;

export const Title = styled.div`
    display: flex;
    position: relative;
    color: #5e6278;
    margin-bottom: 10px;
`;


export const ContainerLegend = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 146px;
  padding: 25px;
  border-radius: 5px;
  background-color: #f4e6fb;
`;

export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: column;
  width: 100px;
  height: 100px;
  padding: 25px;
  border-radius: 50%;
  background-color: #f4e6fb;

  @media screen and (max-width: 450px) {
    width: 300px;
  }
`;
